/** Models */
import { BydHttpParams } from '../configs/http/byd-http-params';
/** Types */
import { ParamsFromObjectType } from '../types/byd-params-from-object.type';
import { BydCleanParams } from './byd-clean-params.function';
/** Functions */

/**
 * Generate new parameters it replaces the value for a parameter.
 *
 * @param filters the filters object
 * @returns BydHttpParams
 */
export function BydGenerateParams<T>(filters: T) {
  if (filters) {
    return new BydHttpParams(<ParamsFromObjectType>{ fromObject: BydCleanParams(filters) });
  }
}
